import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

document.querySelectorAll('.products-slider').forEach((slider, index) => {
    const nextButton = slider.querySelector('.swiper-next-btn');
    const prevButton = slider.querySelector('.swiper-prev-btn');
    if (nextButton) {
        nextButton.classList.add(`swiper-next-btn-${index}`);
    }
    if (prevButton) {
        prevButton.classList.add(`swiper-prev-btn-${index}`);
    }

    const swiper = new Swiper(slider.querySelector('.swiper'), {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        speed: 700,
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
            550: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: parseInt(slider.getAttribute('data-columns'), 10) || 3,
            },
        },
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            nextEl: `.swiper-next-btn-${index}`,
            prevEl: `.swiper-prev-btn-${index}`,
        },
    });
});
